import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 50,
      bottom: 10,
    },
  },
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: true,
      // text: "Energy Generated",
    },
    datalabels: {
      anchor: "end",
      align: "end",
      font: {
        size: 14,
        weight: "bold",
      },
      color: "white",
      rotation: -90,
      formatter: (value) => (value ? `${value} wh` : "0 wh"),
    },
  },
  scales: {
    x: {
      display: true,
      grid: {
        drawBorder: false,
        lineWidth: 0,
      },
      ticks: {
        font: {
          size: 16,
        },
      },
    },
    y: {
      display: false,
      min: 0,
      max: 28,
      grid: {
        drawBorder: false,
        lineWidth: 0,
      },
    },
  },
};

export const EnergyChart = (props) => {
  const { graphData } = props || {};
  //   const labels = ["08:00", "09:00", "10:00", "11:00", "12:00", "01:00"];

  const labels = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0") + ":00"
  );
  // const rawHours = Array.from({ length: 24 }, (_, i) => `${i}:00`);
  const energyValue = labels.map((hour) => {
    const value = graphData?.[hour];
    return value ? parseFloat(value).toFixed(2) : 0;
  });

  const data = {
    labels,
    datasets: [
      {
        // label: "",
        data: energyValue,
        backgroundColor: `rgba(86, 98, 245, 1)`,
        barPercentage: 0.85,
        categoryPercentage: 0.85,
      },
    ],
  };
  return <Bar options={options} data={data} />;
};
